/*
 Auto-generated by generate-java-to-ts-maven-plugin. Do not edit.
 Source: de.mhus.vance.api.notification.NotificationSeverity
*/
export var NotificationSeverity;
(function (NotificationSeverity) {
    NotificationSeverity["INFO"] = "INFO";
    NotificationSeverity["WARN"] = "WARN";
    NotificationSeverity["ERROR"] = "ERROR";
})(NotificationSeverity || (NotificationSeverity = {}));
//# sourceMappingURL=NotificationSeverity.js.map